import React, { useMemo, useState, useEffect } from "react";
import Customtable from "../../helper/Customtable";
import Swal from 'sweetalert2';
import { post } from "../../helper/api_helper"
import { useNavigate } from "react-router-dom";
const Tobacco_user = () => {
    const navigate = useNavigate();
    const [Tobacco_userList, setTobacco_userList] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const columns = useMemo(
        () => [
            {
                header: 'S.No',
                label_condition: 's_no',
                enableColumnFilter: false,
                enableSorting: false,
            },
            {
                header: 'Username',
                accessorKey: 'username',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Mobile No.',
                cell: ({ row }) => (
                    <>
                        <b style={{"cursor": "pointer"}}><span
                            className="text-primary"
                            onClick={() => navigate("/user_detail", { state: { mobile_no: row.mobile_no } })}
                            >
                            {row.mobile_no}
                        </span></b>
                    </>
                ),
                accessorKey: 'mobile_no',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Age',
                accessorKey: 'age',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Location',
                accessorKey: 'location',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Tobacco Product',
                accessorKey: 'tobacco_user_product',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition : "array"
            },
            {
                header: 'Year of Use',
                accessorKey: 'year_of_use',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Per day Spend',
                accessorKey: 'per_day_spend',
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: 'Score',
                accessorKey: 'score',
                enableColumnFilter: false,
                enableSorting: true,
                label_condition : "icon"
            }
        ],
        []
    );
    
    const showAlert = (icon, title, text, timer = 2000) => {
        Swal.fire({ icon, title, text: text || 'Something went wrong.', timer, showConfirmButton: false });
    };

    const fetchData = async () => {
        try {
            const response = await post("tobacco_user_list");
            if (response.status === 200) {
                setTobacco_userList(response.data);
            } else {
                showAlert('error', response.status, response.message);
            }
        } catch (err) {
            showAlert('error', 'Unexpected Error', err.message);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    return (
       <React.Fragment>
      <div className="row">
        <div className="col-lg-12">
          <div className="card basic-data-table">
            <div className="card-header">
              <h5 className="card-title mb-0">Tobacco User List</h5>
            </div>
            <div className="card-body">
              <Customtable
                table_title="Tobacco_user List"
                columns={columns}
                data={Tobacco_userList}
                isGlobalFilter={true}
                isPagination={true}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                isExportButton={true}
              />
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
    );
};

export default Tobacco_user;
